import { manageApiKeys } from 'common/constants/permissions';

const canViewAPIKeys = permissions => permissions[manageApiKeys];

export default {
    canViewAPIKeys
};
